import React, { useState } from 'react';

import { menuIcon } from '../../../../../configs/Icons';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import useApi from '../../../../hook/useApi';
import InstOption from '../../../../utils/InstOption';
import {
    CameraIcon,
    ImageUploadingIcon,
    OptionTransparentIcon,
    ReloadGrIcon
} from '../../../../utils/SVGIcon';
import { TextCapitalize } from '../../../../utils/TextFormatter';
import { useAgencyInfo } from '../../AgencyInfoProvider';
import ModalAgencyStatusChange from '../../List/Modals/ModalAgencyStatusChange';
import AgencyInfoPageHeaderCard from './AgencyInfoPageHeaderCard';

function ButtonWrapper({ children, className, onClick }) {
    return (
        <span className="h-full">
            <button
                type="button"
                className={`h-[34px] block text-sm font-e text-secondary bg-[rgba(255,255,255,0.80)] backdrop-blur-[2px] rounded-5 ${className}`}
                onClick={onClick}
            >
                {children}
            </button>
        </span>
    );
}
function ActionArea() {
    const { agencyInfoData, handleReload } = useAgencyInfo();
    const [showMenu, setShowMenu] = useState(false);
    const { openModal, setConfirm } = useTemplate();

    // -- Change Customer Status Handler
    const handleAgencyStatusModal = (e, data) => {
        e.stopPropagation();
        setConfirm({
            showButton: false,
            text: <ModalAgencyStatusChange data={data} onReload={handleReload} />
        });
    };

    const isStatusActive = agencyInfoData?.status === 'active';

    return (
        <div className="flex items-center gap-x-2.5 absolute top-2.5 right-2.5">
            <div className="flex items-center gap-x-2.5">
                <ButtonWrapper className="w-[34px] p-1" onClick={handleReload}>
                    <ReloadGrIcon />
                </ButtonWrapper>
                <div className="flex flex-row w-full justify-end relative">
                    <ButtonWrapper className="w-[34px]" onClick={() => setShowMenu(!showMenu)}>
                        <span className="w-full block">
                            <OptionTransparentIcon />
                        </span>
                    </ButtonWrapper>

                    <InstOption showMenu={showMenu} setShowMenu={setShowMenu}>
                        {/* Edit Customer info */}
                        {isStatusActive && (
                            <button
                                type="button"
                                onClick={() =>
                                    openModal('UPDATE_AGENCY_INFO_MODAL', {
                                        id: agencyInfoData?.id,
                                        firstName: agencyInfoData?.userInfo?.firstName,
                                        lastName: agencyInfoData?.userInfo?.lastName,
                                        organization: agencyInfoData?.organization,
                                        primaryEmail: agencyInfoData?.userInfo?.email,
                                        primaryPhone: agencyInfoData?.userInfo?.phone
                                    })
                                }
                            >
                                Edit Info
                            </button>
                        )}
                        {isStatusActive && (
                            <button
                                type="button"
                                onClick={() =>
                                    openModal('CHANGE_AGENCY_CURRENCY_MODAL', {
                                        agencyId: agencyInfoData?.id,
                                        currency: agencyInfoData?.currency
                                    })
                                }
                            >
                                Change Currency
                            </button>
                        )}
                        <button
                            type="button"
                            onClick={(event) => handleAgencyStatusModal(event, agencyInfoData)}
                        >
                            {isStatusActive ? 'Make Inactive' : 'Make Active'}
                        </button>
                    </InstOption>
                </div>
            </div>
        </div>
    );
}

function ProductDetails({ customerInfo }) {
    const { handleReload } = useAgencyInfo();
    const { id, photoUrl, role } = customerInfo;
    const { setMessage } = useTemplate();
    // const { authStateUpdated } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const { put } = useApi();

    const handleUpload = (e) => {
        if (!e.target.files[0]) return;
        setIsLoading(true);
        const formData = new FormData();
        formData.append('profileImage', e.target.files[0]);
        put(`api/customers/${id}/change-profile-image`, formData, null, {
            'Content-Type': 'multipart/form-data'
        })
            .then(({ error, message }) => {
                if (error) throw new Error(message);
                setMessage({ type: 'success', text: message });
                // authStateUpdated();
                handleReload();
                setIsLoading(false);
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err?.toString(0) });
                setIsLoading(false);
            });
    };

    const isCustomerInactive = customerInfo?.status === 'inactive';

    return (
        <div className="overflow-hidden">
            <div className="size-[100px] bg-[#E6F6ED] relative rounded-full p-4 mb-4">
                <span className="w-full block">
                    {isLoading ? (
                        <ImageUploadingIcon />
                    ) : (
                        <img
                            src={photoUrl || menuIcon.settingsWL}
                            alt=""
                            className="w-full block"
                        />
                    )}
                </span>
                <label
                    type="button"
                    className={`absolute bottom-0 right-0 size-[31px] p-[7px] text-primary bg-white rounded-full cursor-pointer ${
                        isCustomerInactive ? 'invisible' : ''
                    }`}
                >
                    <input
                        type="file"
                        className="hidden"
                        onChange={handleUpload}
                        accept="image/png, image/jpeg, image/jpg"
                    />
                    <CameraIcon />
                </label>
            </div>
            <div className="flex flex-col ite gap-1">
                <div className="flex items-center gap-2.5 relative text-primary text-2xl font-medium whitespace-nowrap  text-ellipsis">
                    <span> {customerInfo?.organization || '----'}</span>

                    {customerInfo?.currency ? (
                        <span className="bg-[#FFA016] text-sm text-white uppercase py-[3px] px-2.5 rounded-[4px]">
                            {TextCapitalize(customerInfo?.currency) || '--'}
                        </span>
                    ) : null}
                </div>
                <p className="text-sm text-primary">
                    <span>{customerInfo?.primaryEmail || '---'}</span>
                </p>
                <span>
                    <b>{TextCapitalize(role)}</b>
                </span>
            </div>
        </div>
    );
}

function AgencyInfoPageHeader() {
    const { agencyInfoData } = useAgencyInfo();
    // const [showMenu, setShowMenu] = useState(false);

    // const isStatusActive = agencyInfoData?.status === 'active';

    return (
        <div
            className={`customer-info-bg relative w-full overflow-hidden h-auto flex-wrap lg:flex-nowrap gap-y-6 gap-x-2.5 z-10 2xl:max-h-[260px] min-h-[260px] p-2.5 mb-4 2xl:flex justify-between 2xl:gap-3 ${
                agencyInfoData?.demo ? 'placeholder-mode' : ''
            }`}
        >
            {/* product information */}
            <div className="flex flex-1 pl-5 relative mb-9">
                <ProductDetails customerInfo={agencyInfoData} />
            </div>

            {/* customer info card */}
            <div className="flex items-end">
                <AgencyInfoPageHeaderCard />
            </div>

            {/* section action buttons */}
            <ActionArea />
        </div>
    );
}

export default AgencyInfoPageHeader;
